const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
const YEAR_MONTH_FORMAT = 'YYYY-MM';

export default {
  DATE_FORMAT,
  YEAR_MONTH_FORMAT,
  DATE_TIME_FORMAT,
};
